import { motion } from "framer-motion";

interface SectionRevealProps {
    children: React.ReactNode;
    direction?: "left" | "right";
}

/**
 * Wraps a section with a diagonal curtain-wipe clip-path reveal on scroll.
 */
const SectionReveal = ({ children, direction = "left" }: SectionRevealProps) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10px" }}
            transition={{ duration: 0.8, ease: "easeOut" }}
        >
            {children}
        </motion.div>
    );
};

export default SectionReveal;
